export const GET_CAMPAIGN_LIST = 'GET_CAMPAIGN_LIST';